import pickBy from 'lodash-es/pickBy';

import type { ReeferAccessibilityDataProps } from './baseProps.types';

export function getAccessibilityDataProps(props: ReeferAccessibilityDataProps) {
  return [
    pickBy(props, (value, key) => key.startsWith('aria-')),
    pickBy(props, (value, key) => key.startsWith('data-')),
    pickBy(
      props,
      (value, key) => !key.startsWith('aria-') && !key.startsWith('data-')
    ),
  ];
}
